// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { BlockFragmentDoc } from '../../../components/cms/CmsBlock.fragment.generated';
import { JewelleryLinkFragmentDoc } from '../../../router/fragments/jewelleryLink.fragment.generated';
import { MetaFragmentDoc } from '../../../graphql/api/fragments/meta.fragment.generated';
import { PageTooltipFragmentDoc } from '../../../components/layout/tooltip/PageTooltip.fragment.generated';
import { PdpAccordionItemFragmentDoc } from '../../../components/product/PdpAccordion.generated';
import { CtaBoxFragmentDoc } from '../components/CtaBox.generated';
import { JewelleryFragmentDoc } from '../../../graphql/api/product/rings/jewellery/jewellery.fragment.generated';
import { ShopWithConfidenceProductFragmentDoc } from '../../../components/cms/component/ComponentShopWithConfidence.generated';
import { AffirmFinanceOptionsFragmentDoc } from '../../../graphql/api/checkout/payment/affirmFinanceOptions.fragment.generated';
import { ReviewsFragmentDoc } from '../../../components/rings/Reviews.generated';
import { ReviewsAggregateFragmentDoc } from '../../../components/rings/ReviewsAggregate.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export const JewelleryDetailsFragmentDoc = gql`
    fragment jewelleryDetails on CatalogueJewellery {
  ...jewellery
  ...jewelleryLink
  ...shopWithConfidenceProduct
  ... on CatalogueJewelleryRing {
    isResizeable
  }
  financeOptionsAffirm(currency: $currency, country: $country) {
    ...affirmFinanceOptions
  }
  reviews {
    ...reviews
  }
  reviewsAggregate {
    ...reviewsAggregate
  }
}
    ${JewelleryFragmentDoc}
${JewelleryLinkFragmentDoc}
${ShopWithConfidenceProductFragmentDoc}
${AffirmFinanceOptionsFragmentDoc}
${ReviewsFragmentDoc}
${ReviewsAggregateFragmentDoc}`;
export const JewelleryDetailsDocument = gql`
    query jewelleryDetails($slug: String!, $metal: MetalCode!, $suffixSlug: String, $locale: Locale!, $country: CountryCode!, $currency: CurrencyInput!, $page: String!, $pageFallback: String!, $type: CatalogueJewelleryType!) {
  catalogueJewellery(
    filter: {slug: $slug, suffixSlug: $suffixSlug, primaryMetalCode: $metal}
    type: $type
  ) {
    ...jewelleryDetails
  }
  pageProductDetails(path: $page, fallback: $pageFallback, locale: $locale) {
    id
    blocks {
      ...block
    }
    meta {
      ...meta
    }
    priceExplainedTooltip {
      ...pageTooltip
    }
    accordionItems {
      ...pdpAccordionItem
    }
    ...ctaBox
  }
}
    ${JewelleryDetailsFragmentDoc}
${BlockFragmentDoc}
${MetaFragmentDoc}
${PageTooltipFragmentDoc}
${PdpAccordionItemFragmentDoc}
${CtaBoxFragmentDoc}`;

export function useJewelleryDetailsQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.JewelleryDetailsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.JewelleryDetailsQuery, SchemaTypes.JewelleryDetailsQueryVariables | undefined>({ query: JewelleryDetailsDocument, variables: undefined, ...options });
};